export default __webpack_public_path__ + "static/media/Vector.f38919a7.svg";